var map = {
	"./NRP.jpg": "pLyr",
	"./bauges-park.jpg": "dlX9",
	"./brel.jpg": "mjNv",
	"./camonica-valley.jpg": "Zu6P",
	"./cassiano.jpg": "RJcO",
	"./crepa.jpg": "skj6",
	"./dislivelli-association.jpg": "xPuL",
	"./europe-logo.jpg": "jNpv",
	"./european-year.jpg": "3cM1",
	"./european-year.png": "+G02",
	"./kedge-business-school.jpg": "hyH3",
	"./lombardy-region.jpg": "1phh",
	"./munich-university-of-applied-sciences.jpg": "XD4g",
	"./polo-poschiavo.jpg": "qxbl",
	"./ragor.jpg": "g+Sx",
	"./rda.jpg": "V2UA",
	"./tsm.jpg": "ruDj",
	"./uibk.jpg": "MYcH",
	"./zrc-sazu.jpg": "GQI/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "B9Mr";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main_supporters ^\.\/.*$
// module id = B9Mr
// module chunks = 1